import {
  DOCUMENT_CAPTURE_RESPONSE_API_KEYS,
  Image,
} from '../DocumentCapture.helpers';

import { Input } from './pages/uploadImageReducer.types';

export const documentNeedsReupload = (input: Input | Image) =>
  Boolean(
    input?.actions
      && input.actions[
        DOCUMENT_CAPTURE_RESPONSE_API_KEYS.DOCUMENTS_IMAGE_ACTION_REUPLOAD
      ]?.value,
  );

export const documentHasBeenApproved = (input: Input) =>
  Boolean(
    input?.actions
      && input.actions[
        DOCUMENT_CAPTURE_RESPONSE_API_KEYS.DOCUMENTS_IMAGE_ACTION_REUPLOAD
      ]?.value === false,
  );
